"use strict";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFailure = exports.fetchSuccess = exports.fetchRequest = void 0;
const types = require("./types");
const fetchRequest = () => ({
    type: types.FETCH_REQUEST
});
exports.fetchRequest = fetchRequest;
const fetchSuccess = (config) => ({
    config,
    type: types.FETCH_SUCCESS
});
exports.fetchSuccess = fetchSuccess;
const fetchFailure = (errorMessage) => ({
    errorMessage,
    type: types.FETCH_FAILURE
});
exports.fetchFailure = fetchFailure;
//# sourceMappingURL=actions.js.map